import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import { ORGANIZATION_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

export const transformAggJCSOrganizationToLegacyField: FieldTransformer<
	typeof ORGANIZATION_CF_TYPE
> = (node) => {
	if (node.type !== ORGANIZATION_CF_TYPE) return undefined;

	return {
		...transformAggNodeToLegacyField(node),
		value: node.selectedOrganization,
		schema: {
			configuration: null,
			custom: ORGANIZATION_CF_TYPE,
			items: 'sd-customerorganization',
			renderer: PLAIN_TEXT,
			system: null,
			type: 'array',
		},
	};
};
